import { Stack, StackProps, styled } from '@mui/material';

import Button from '../../../components/Button';
import ListItem from '../../../components/ListItem';
import { forMobile } from '../../../utils/media-queries';

export const NotificationCell = styled((props: StackProps) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" component={ListItem} {...props} />
))(({ theme }) => ({
  padding: theme.spacing(3, 5),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  [forMobile(theme)]: {
    minWidth: 92,
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  minWidth: 100,
  [forMobile(theme)]: {
    flex: 1,
  },
}));
